import React from 'react';
import { FormattedMessage } from 'react-intl';

import { UserCard } from '../../components';
import css from './ListingPage.css';

const SectionHostMaybe = props => {
  const {
    listing,
    currentUser,
  } = props;

  if (!listing.author) {
    return null;
  }

  return (
    <div id="host" className={css.sectionHost}>
      <UserCard user={listing.author} currentUser={currentUser} />
    </div>
  );
};

export default SectionHostMaybe;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/SectionHostMaybe.js